const EVENT_H_SCROLL = 'sync:h-scroll'
const CLASS_CLIENT = 'c-shs-client'

function handlerClient (el) {
  return function () {
    const e = new CustomEvent(EVENT_H_SCROLL, {
      bubbles: true,
      detail: { src: el, offsetx: el.scrollLeft }
    })
    el.dispatchEvent(e)
  }
}

const Client = {
  data: () => ({
    shsc: {
      CLASS: CLASS_CLIENT,
      handler: null
    }
  }),

  mounted () {
    const el = this.$el
    this.shsc.handler = handlerClient(el)
    el.addEventListener('scroll', this.shsc.handler)
  },

  beforeDestroy () {
    const el = this.$el
    el.removeEventListener('scroll', this.shsc.handler)
    this.shsc.handler = null
  }
}

function handlerHost (el) {
  let ticking = 0
  let elems = null
  let src = null
  let offsetx = 0

  return function (event) {
    src = event.detail.src
    offsetx = event.detail.offsetx

    if (ticking) {
      return
    }

    ticking = requestAnimationFrame(function () {
      ticking = 0

      if (!elems) {
        elems = el.querySelectorAll(`.${CLASS_CLIENT}`)
      }

      for (let i = 0, len = elems.length; i < len; ++i) {
        if (elems[i] !== src) {
          elems[i].scrollLeft = offsetx
        }
      }
    })
  }
}

const Host = {
  data: () => ({
    shsh: {
      handler: null
    }
  }),

  mounted () {
    const el = this.$el
    this.shsh.handler = handlerHost(el)
    el.addEventListener(EVENT_H_SCROLL, this.shsh.handler)
  },

  beforeDestroy () {
    const el = this.$el
    el.removeEventListener(EVENT_H_SCROLL, this.shsh.handler)
    this.shsh.handler = null
  }
}

export default {
  Host,
  Client
}
